/** 音量・消音(どの画面からも触れる小さなコントロール)。 */

import { useGameStore } from '../store/gameStore';

export function SoundToggle() {
  const settings = useGameStore((state) => state.settings);
  const setVolume = useGameStore((state) => state.setVolume);
  const toggleMuted = useGameStore((state) => state.toggleMuted);

  return (
    <div className="sound-toggle">
      <button
        type="button"
        className={`mute ${settings.muted ? 'off' : 'on'}`}
        onClick={toggleMuted}
        aria-label={settings.muted ? 'おとを だす' : 'おとを けす'}
      >
        {settings.muted ? '🔇' : '🔊'}
      </button>
      <input
        type="range"
        min={0}
        max={100}
        value={Math.round(settings.volume * 100)}
        onChange={(event) => setVolume(Number(event.target.value) / 100)}
        aria-label="おんりょう"
      />
    </div>
  );
}
